import { BaseInputModel } from '@/helpers/entities/models/BaseInputModel';
import { State } from '@/helpers/entities/enums/v2/State';
import { EcommerceProductCityPriceHikeInputModel } from './EcommerceProductCityPriceHikeInputModel';
export class EcommerceProductRegionAvailabilityInputModel extends BaseInputModel {
    constructor(payload = null, isNew, productCityPriceHikes = null) {
        super();
        if (payload) {
            Object.assign(this, {
                ...payload,
                state: isNew ? State.new : State.idle,
                persistent: !isNew,
            });
            if (productCityPriceHikes) {
                this.productCityPriceHikes = productCityPriceHikes.map((city) => {
                    return new EcommerceProductCityPriceHikeInputModel(city);
                });
            }
            else {
                this.productCityPriceHikes = [];
            }
        }
        else {
            this.init();
        }
    }
    generateCityPriceHike() {
        this.productCityPriceHikes.push(new EcommerceProductCityPriceHikeInputModel());
    }
    markAsIdle() {
        this.state = State.idle;
    }
    markAsNew() {
        this.state = State.new;
    }
    init() {
        this.uuid = null;
        this.regionCode = null;
        this.name = null;
        this.productCityPriceHikes = [];
        this.state = State.new;
    }
}
